<template>
  <div>
    <div id="PengajuanMasuk">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Pengajuan Masuk</h2>
        </div>
        <div class="col-sm-4 text-right">
          <b-button 
            :disabled="isLoading"
            variant="primary" 
            class="btn btn-custom theme-color px-4 rounded-5" 
            @click="downloadPengajuanMasukMitra"
          >
            <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
            <span v-if="!isLoading">Download</span>
          </b-button>
        </div>
      </div>
      <div class="row no-gutters mb-4">
        <div class="col-md-3">
          Search
          <div class="input-group">
            <input type="text" class="form-control mb-2" id="autoSizingInputGroup" placeholder="search..">
            <button class="input-group-text mb-2"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
      <div class="overflow-auto">
        <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields" :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
          <template v-slot:cell(id_transaksi)="data">
            <div>{{ data.item.id }}</div>
          </template>
          <template v-slot:cell(funder)="data">
            <div>{{ data.item.funder.name }}</div>
          </template>
          <template v-slot:cell(product)="data">
            <div>{{ data.item.product.nama_produk }}</div>
          </template>
          <template v-slot:cell(setoran_awal)="data">
            <div>Rp. {{ new Intl.NumberFormat().format(data.item.setoran_awal) }}</div>
          </template>
          <template v-slot:cell(is_apuppt)="data">
            <div
              :style="{
                color: parseFloat(data.item.setoran_awal || 0) >= 500000000 ? 'red' : 'green'
              }"
            >
              {{ parseFloat(data.item.setoran_awal || 0) >= 500000000 ? 'Ya' : 'Tidak' }}
            </div>
          </template>
          <template v-slot:cell(is_active_aro)="data">
            <div :style="{ color: data.item.is_active_aro ? 'green' : 'red' }">
              {{ data.item.is_active_aro ? 'Aktif' : 'Tidak Aktif' }}
            </div>
          </template>
          <template v-slot:cell(created_at)="data">
            <div>{{ data.item.created_at }}</div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button @click="$router.push(`/show-pengajuan/${data.item.funder.id}/${data.item.id}`)" type="button" variant="primary" class="btn btn-custom theme-color  rounded-5">
                Detail
            </b-button>
            <b-button @click="changeStatus(data.item)" type="button" variant="success" class="btn btn-custom theme-color success rounded-5">
              Setujui
            </b-button>
            <b-button @click="rejectStatus(data.item)" type="button" variant="danger" class="btn btn-custom theme-color cancel rounded-5">
              Tolak
            </b-button>
            <b-modal size="m" v-model="confirmStatusModal">
              <div class="d-block text-center">
                <h3>{{ modalTitle }}</h3>
              </div>
              <template #modal-footer>
                <div v-if="changingStatus" class="text-center">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-else>
                  <b-button @click="confirmStatusModal = false" variant="danger">Tutup</b-button>
                  <b-button @click="confirmChangeStatus(data.item)" variant="primary">Ya</b-button>
                </div>
              </template>
            </b-modal>

            <b-modal size="md" v-model="confirmRejectStatusModal">
              <div class="d-block text-center">
                <!-- Judul Modal -->
                <!-- <h3 class="font-weight-bold text-primary mb-3 mt-0">Konfirmasi Penolakan</h3>
                <p class="text-secondary mb-4">
                  Anda akan menolak pengajuan ini. Silakan masukkan alasan penolakan di bawah ini.
                </p> -->
                <h3>{{ modalTitle }}</h3>
                <!-- <h4>{{ textModal }}</h4> -->
              </div>

              <template #modal-footer>
                <div v-if="changingStatus" class="text-center">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-else>
                  <b-button @click="confirmRejectStatusModal = false" variant="danger">Tutup</b-button>
                  <b-button @click="rejectStatusConfirm" variant="primary">Ya</b-button>
                </div>
              </template>
            </b-modal>
          </template>
        </b-table>
      </div>

        <h2 v-if="!loaded" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
        <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan" aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>
    </div>

    <b-modal size="m" v-model="successModal">
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Status berhasil diubah</h3>
      </div>
      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="successModal = false" variant="primary">Tutup</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="m" v-model="rejectModal">
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Pengajuan berhasil ditolak</h3>
      </div>
      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="rejectModal = false" variant="primary">Tutup</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';

const pengajuanFields = [
  {
    key: 'id_transaksi',
    label: 'ID Transaksi',
    sortable: false
  },
  {
    key: 'funder',
    label: 'Nama Nasabah',
    sortable: true
  },
  {
    key: 'product',
    label: 'Nama Produk',
    sortable: true
  },
  {
    key: 'setoran_awal',
    label: 'Setoran Awal',
    sortable: true
  },
  { 
    key: 'is_apuppt',
    label: 'APUPPT',
    sortable: false
  },
  {
    key: 'is_active_aro',
    label: 'ARO',
    sortable: false
  },
  {
    key: 'created_at',
    label: 'Created At',
    sortable: true
  },
  {
    key: 'aksi',
    label: 'Aksi',
  },
]

export default {
  name: "ManajemenPengajuan",

  data() {
    return {
      pengajuanItems: [],
      pengajuanFields: pengajuanFields,
      perPagePengajuan: 5,
      produk_id: '',
      pengajuan_id: '',
      currentPagePengajuan: 1,
      confirmDeleteModal: false,
      loaded: false,
      confirmRejectStatusModal: false,
      confirmStatusModal: false,
      successModal: false,
      modalTitle: '',
      changingStatus: false,
      rejectModal: false,
      textModal: '',
      isLoading: false,
    }
  },

  computed: {
    rowsPengajuan() {
      return this.pengajuanItems.length;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      Pengajuan.pengajuanListMitraPendukungV3()
        .then(res => {
          const filteredData = res.data.data.filter(item => {
            return item.funder.role_id === 3;
          });
          this.pengajuanItems = filteredData;
          // console.log("woyorang",this.pengajuanItems);
          this.loaded = true;
        })
        .catch(err => console.log(err));
    },
    changeStatus(item) {
      this.product_id = item.id;
      this.modalTitle = 'Apakah anda yakin ?';
      this.confirmStatusModal = true;
    },
    rejectStatus(item) {
      this.pengajuan_id = item.id;
      this.modalTitle = 'Apakah anda yakin akan menolak pengajuan ini ?';
      // this.textModal = 'Anda akan menolak pengajuan ini ?';
      this.confirmRejectStatusModal = true;
    },
    rejectStatusConfirm() {
      this.changingStatus = true;
      Pengajuan.rejectStatus(this.pengajuan_id)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmRejectStatusModal = false;
            this.rejectModal = true;
            this.loadData();
          } else {
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.changingStatus = false;
        });
    },
    confirmChangeStatus(item) {
      this.changingStatus = true;
      const data = {
        id: this.product_id
      }

      Pengajuan.changeStatus(data)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmStatusModal = false;
            this.changingStatus = false;
            this.successModal = true;
            this.loadData();
          } else {
            console.log(res.data);
            this.changingStatus = false;
          }
        })
        .catch(err => console.log(err));
    },
    downloadPengajuanMasukMitra() {
      this.isLoading = true;
      Pengajuan.downloadDataFunderPengajuanMasuk(3)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'pengajuan_masuk_mitra.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
  /* Mengaktifkan scroll horizontal */
  white-space: nowrap;
  /* Mencegah pembungkusan teks */
}

.b-table {
  min-width: 800px;
  /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
.btn-disabled {
  background-color: #d5a031  !important;
  color: #ffffff !important;
  opacity: 1; /* Hilangkan efek transparan */
  cursor: not-allowed; /* Tetap tidak interaktif */
  pointer-events: none; /* Tidak bisa diklik */
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pengajuan-masuk.vue